export default __webpack_public_path__ + "static/img23h-14b0fcff88c50015c159bf8be04d309b.jpg";